/**
 * @file Derives analytics facts from a rights map: can read (`metricsRead`,
 * `metricsOrgRead` or `metricsAdmin`), can read Org (`metricsOrgRead` or
 * `metricsAdmin`) and is admin (`metricsAdmin`). Consumers: the Navb Analytics
 * entry, `useHomeAnalyticsSummary`, the Settings → Analytics entry and
 * sections, and the Goals rows, which check every listed user's rights. A
 * right counts only when it is exactly `true`; `orgsAdmin` never counts,
 * because the rules ignore it.
 */
import type { AnalyticsRights } from './index.types';

export const analyticsRights = (
  userRights: Partial<Record<string, boolean>>,
): AnalyticsRights => {
  const isAdmin = userRights.metricsAdmin === true;
  const canReadOrg = isAdmin || userRights.metricsOrgRead === true;
  const canRead = canReadOrg || userRights.metricsRead === true;
  return { canRead, canReadOrg, isAdmin };
};
